export enum DataState {
    Done, Loading, Saving, Deleting, Deleted, Duplicating
}


// WEBPACK FOOTER //
// ./src/Models/Common/DataState.ts